<template>
  <Modal
    id="CompanyDetail"
    width="60%"
    :visible="visible"
    @cancel="visible = !visible"
    @ok="visible = !visible"
    :title="$t('leave.name.detailTitle')"
  >
    <Descriptions>
      <DescriptionsItem :label="$t('leave.field.id_lea')">{{
        data.idLea
      }}</DescriptionsItem>
      <DescriptionsItem :label="$t('leave.field.id_emp')">{{
        data.employeeNickName
      }}</DescriptionsItem>
      <DescriptionsItem :label="$t('leave.field.submit_time')">{{data.submitTime}}</DescriptionsItem>
      <DescriptionsItem :label="$t('leave.field.leave_type')">{{
        data.leaveTypeLeaveTypeName
      }}</DescriptionsItem>
      <DescriptionsItem :label="$t('leave.field.status')">{{
        this.selectList.statusList.find(item=>item.value===data.status).label
      }}</DescriptionsItem>
      <DescriptionsItem :label="$t('leave.field.duration')">{{
        duration
      }}</DescriptionsItem>
      <DescriptionsItem :label="$t('leave.field.start_time')">{{
        data.startTime
      }}</DescriptionsItem>
      <DescriptionsItem :label="$t('leave.field.end_time')">{{
        data.endTime
      }}</DescriptionsItem>
      <DescriptionsItem :label="$t('leave.field.reason')">{{
        data.reason
      }}</DescriptionsItem>
      <DescriptionsItem :label="$t('leave.field.approver_id')">{{
        data.approverNickName
      }}</DescriptionsItem>
      <DescriptionsItem :label="$t('leave.field.approve_time')">{{
        data.approveTime
      }}</DescriptionsItem>
      <DescriptionsItem :label="$t('leave.field.reject_reason')">{{
        data.rejectReason
      }}</DescriptionsItem>
      <!-- <DescriptionsItem :label="$t('leave.field.cc')">{{
        data.cc
      }}</DescriptionsItem> -->


      <DescriptionsItem :label="$t('leave.field.approver2_id')">{{
        data.approver2NickName
      }}</DescriptionsItem>
      <DescriptionsItem :label="$t('leave.field.approve2_time')">{{
        data.approve2Time
      }}</DescriptionsItem>
      <DescriptionsItem :label="$t('leave.field.remark')">{{
        data.remark
      }}</DescriptionsItem>
      <!-- <DescriptionsItem :label="$t('leave.field.picture_url')">
          <Image
            :width="200"
            :src="data.pictureUrl"
            fallback="data:image/png;base64,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"
          />
        </DescriptionsItem> -->
      	

    </Descriptions>
  </Modal>
</template>

<script>
import { Modal, Descriptions, DescriptionsItem, Image } from "ant-design-vue";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons-vue";

export default {
  name: "LeaveDetail",
  components: {
    Modal,
    LoadingOutlined,
    PlusOutlined,
    Descriptions,
    DescriptionsItem,
    Image,
  },
  data() {
    return {
      data: {},
      visible: false,
      selectList:{
        employeeList: [],
        leaveTypeList: [],
        departmentList: [],
        //leaveTypeList: [{value: 1,label: '調休'},{value: 2,label: '年假'},{value: 3,label: '產假'},{value: 4,label: '侍產假'},{value: 5,label: '事假'},{value: 6,label: '病假'},{value: 7,label: '婚假'}],
        statusList: [{value: 0,label: '待發送'},{value: 1,label: '待審批'},{value: 2,label: '已拒絕'},{value: 3,label: '已通過'}],
	timeFrameList: [{value: 1,label: 'AM'},{value: 2,label: 'PM'}],
      }
    };
  },
  computed: {
    duration: function () {
      // var days = Math.floor(this.data.duration / 480);
      // var hours = Math.floor((this.data.duration % 480) / 60);
      // var minutes = this.data.duration % 60;
      // var result = "";
      // if (days !== 0) {
      //   result = days + "天";
      // }
      // if (hours !== 0) {
      //   result = result + hours + "小時";
      // }
      // if (minutes !== 0) {
      //   result = result + minutes + "分鐘";
      // }
      return this.data.duration + '天';
    },
  },
  methods: {
    async detailShow(obj) {
      this.data = JSON.parse(JSON.stringify(obj));
      this.visible = true;
    },
  },
};
</script>

<style lang="less">
</style>